module.exports = __webpack_public_path__ + "img/BRCA4_CD4Tconv.06f59436.png";